import { render, staticRenderFns } from "./realTimeInfoIndex.vue?vue&type=template&id=07048d1e&scoped=true"
import script from "./realTimeInfoIndex.vue?vue&type=script&lang=js"
export * from "./realTimeInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./realTimeInfoIndex.vue?vue&type=style&index=0&id=07048d1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07048d1e",
  null
  
)

export default component.exports